import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

import { SelectModule } from '../select/select.module'
import { NavbarComponent } from './navbar.component'
import { MenuComponent } from './menu'
import { CustomMaterialModule } from '../material/custom-material.module'
import { UtilsModule } from '../utils/utils.module'
import { TeamChipListComponent } from './team-chip-list/team-chip-list.component'

@NgModule({
  imports: [
    CommonModule,
    CustomMaterialModule,
    UtilsModule,
    SelectModule,
  ],
  declarations: [
    NavbarComponent,
    MenuComponent,
    TeamChipListComponent,
  ],
  exports: [
    NavbarComponent,
    MenuComponent,
    TeamChipListComponent,

  ]
})
export class NavbarModule { }



// WEBPACK FOOTER //
// ./src/app/shared/navbar/navbar.module.ts